<template>
  <div>
    <wx-open-launch-weapp v-show="showBtn" id="launch-btn" env-version="trial" appid="wxcd42a25920f6dcfd" path="pages/sub/event-activity/activity?id=9043fa02-7348-4144-b250-c9be31b5313f">
      <script type="text/wxtag-template">
        <style>.btn {width: 200px; height: 100px;}</style>
        <button class="btn">打开测试小程序</button>
      </script>
    </wx-open-launch-weapp>
  </div>
</template>

<script>
export default {
  name: "appletOpen",
  data() {
    return {
      showBtn: true
    }
  },
  created () {
    this.getConfig();
  },
  methods: {
    getConfig () {
      let _this = this
      let data = {
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
        appId: 'wxd7352147e74ada09', // 必填，公众号的唯一标识
        timestamp: '1719469754', // 必填，生成签名的时间戳
        nonceStr: 'r1n1y5', // 必填，生成签名的随机串
        signature: '46530a1b848a5072221da7f0a5cd247275b09f61',// 必填，签名
        jsApiList: ['chooseImage', 'previewImage', 'chooseWXPay'], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
      }
      console.log('getConfig',data)
      wx.config(data);
      wx.ready(function (e) {
        _this.showBtn = true
        console.log('ready',e)
      })
      wx.error(function (e) {
        console.log('error',e)
      })
    },
    openMiniProgram() {
      // 以下参数需要根据实际情况进行配置
      const appId = 'wxcd42a25920f6dcfd'; // 小程序appid
      const path = 'pages/sub/event-activity/activity'; // 打开的页面路径
      const extraData = {
        // 需要传递给小程序的数据
        id: '9043fa02-7348-4144-b250-c9be31b5313f'
      };

      // 微信小程序的打开方式
      if (window.wx) {
        window.wx.miniProgram.navigateTo({ url: `/${path}`, extraData });
      } else {
        alert('请在微信内置浏览器中使用');
      }
    },
  }
}
</script>

<style scoped>

</style>
